import { patchState, signalStore, withHooks, withMethods, withState } from "@ngrx/signals";
import { SettingsService } from "../services/settings/settings.service";
import { inject } from "@angular/core";

type AppState = {
    filterForTargetedHCC: boolean;
    targetedHccToggleDisabled: boolean;
    username: string;
    serviceYear: number | null;
}

const initialState: AppState = {
    filterForTargetedHCC: true,
    targetedHccToggleDisabled: false,
    username: '',
    serviceYear: null
}

export const AppStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store) => ({
        setFilterForTargetedHCC(value: boolean): void {
            patchState(store, { filterForTargetedHCC: value });
        },
        setTargetedHccToggleDisabled(value: boolean): void {
            patchState(store, { targetedHccToggleDisabled: value });
        },
        setUsername(value: string): void {
            patchState(store, { username: value });
        },
        setServiceYear(value: number | null): void {
            patchState(store, { serviceYear: value });
        },
    })),
    withHooks({
        onInit(store) {
            const settingsService = inject(SettingsService);
            const subscription = settingsService.serviceYear.subscribe(result => {
                if (result > -1) {
                    patchState(store, { serviceYear: result });
                }
            });
            return () => subscription.unsubscribe();
        },
    }),
);